import { render } from "./InstallationsView.vue?vue&type=template&id=33a15f4e&scoped=true&ts=true"
import script from "./InstallationsView.vue?vue&type=script&lang=ts"
export * from "./InstallationsView.vue?vue&type=script&lang=ts"

import "./InstallationsView.vue?vue&type=style&index=0&id=33a15f4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a15f4e"]])

export default __exports__